import { jsx as _jsx } from "react/jsx-runtime";
import { CheckableAvatarSelectItem, CheckableSelectItem, DropdownSelect, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
/** The available static filters and their attributes. */
const staticFilters = {
    channel: {
        label: 'Channel',
        itemComponent: CheckableAvatarSelectItem,
    },
    direction: {
        label: 'Direction',
        itemComponent: CheckableSelectItem,
    },
    status: {
        label: 'Status',
        itemComponent: CheckableSelectItem,
    },
};
/** Represents the component for displaying a static conversations filter. */
export const ConversationsStaticFilter = ({ type, items, }) => {
    const { itemComponent, label } = staticFilters[type];
    const { params, patchParams, unsetParams } = useAppSearchParams('/conversations');
    /**
     * The search param of the
     * {@link ConversationsStaticFilterType conversations static filter}.
     *
     * Note that we have to re-cast because we can't narrow down the values due to
     * the generic type. Additionally a union of arrays results in value being
     * typed as `never` because an empty array `[]` is technically `never[]`. So
     * instead of dealing with union of arrays we make it a single array of all
     * possible values from static filters, e.g. `'a'[] | 'b'[] -> ('a' |
     * 'b')[]`.
     */
    const selectedDropdownItemIds = useMemo(() => typeof params[type] !== 'undefined'
        ? typeof params[type] === 'string'
            ? [params[type]]
            : params[type]
        : [], [params, type]);
    const handleChange = useCallback((item, checked) => patchParams({
        set: {
            [type]: checked
                ? [...selectedDropdownItemIds, item.id]
                : selectedDropdownItemIds.filter((id) => id !== item.id),
        },
        unset: ['limit', 'offset'],
    }), [patchParams, selectedDropdownItemIds, type]);
    const handleClear = useCallback(() => unsetParams([type, 'limit', 'offset']), [unsetParams, type]);
    return (_jsx(DropdownSelect, Object.assign({ keepOpen: true, noArrow: false, 
        // TODO: [TEAMS-9726] Remove re-casting when fixed in Habla
        items: items, selectedItems: selectedDropdownItemIds, itemComponent: itemComponent, buttonProps: {
            variant: 'tertiary',
            label: selectedDropdownItemIds.length || undefined,
        }, dropdownProps: { style: { minWidth: 280 } }, itemsDisplayCount: items.length, onChange: handleChange, onClear: handleClear }, { children: label })));
};
